import { MarketingBrand } from "./MarketingBrand";

/** Shared Five Crown branding uses the official source PNG on every surface. */
export function Brand({ compact = false, tagline = false }: { compact?: boolean; tagline?: boolean }): React.JSX.Element {
  return <MarketingBrand compact={compact} tagline={tagline} />;
}

const iconPaths: Record<string, string> = {
  installers: "M12 3v12M7 10l5 5 5-5M4 16v5h16v-5",
  overview: "M3 10 12 3l9 7M5 9v12h5v-7h4v7h5V9",
  games: "M7 7h10c4 0 6 13 3 13l-5-4H9l-5 4C1 20 3 7 7 7ZM7 10v5M4.5 12.5h5M16 11h.01M19 14h.01",
  sessions: "M5 5h14v16H5ZM8 3v4M16 3v4M5 10h14M9 14h2M14 14h2M9 17h2",
  cards: "M3 3h7v7H3ZM14 3h7v7h-7ZM3 14h7v7H3ZM14 14h7v7h-7Z",
  patterns: "M8 3h8v5h5v8h-5v5H8v-5H3V8h5Z",
  staff: "M9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM2 21v-2a7 7 0 0 1 14 0v2M17 4a4 4 0 0 1 0 8M18 15a5 5 0 0 1 4 5",
  devices: "M5 3h14v14H5ZM3 21h18l-2-4H5ZM10 14h4",
  settings: "M9 3h6l1 4 4 1 1 6-4 2-1 4-6 1-2-4-4-1-1-6 4-2ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
};
export function ToolIcon({ name }: { name: string }): React.JSX.Element {
  return <svg className="tool-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d={iconPaths[name] ?? iconPaths.cards} /></svg>;
}
